var chunkToChildrenMap = {
	"1994": [
		8714,
		1498
	],
	"2568": [
		1169
	],
	"2791": [
		3658
	],
	"4210": [
		8315
	],
	"6591": [
		2412
	],
	"7360": [
		8714
	],
	"8944": [
		3286
	],
	"9824": [
		1169,
		2898
	]
};
__webpack_require__.f.prefetch = (chunkId, promises) => (Promise.all(promises).then(() => {
	var chunks = chunkToChildrenMap[chunkId];
	Array.isArray(chunks) && chunks.map(__webpack_require__.E);
}));